import * as utils from './utils';
import { formatLatestMessageTimestamp } from './dateHelpers';

/**
 * @param {array} messageCollection
 * @return
 */
export const getLastMessageFromMessages = (messageCollection) =>
  messageCollection
    ? messageCollection.sort((a, b) => new Date(b.Timestamp) - new Date(a.Timestamp))[0]
    : null;

/**
 * @param {array} messageCollection
 * @param {object} user
 * @return
 */
export const getLastUnseenMessageFromMessages = (messageCollection, user) =>
  messageCollection && user
    ? messageCollection
        .sort((a, b) => b.Timestamp - a.Timestamp)
        .find(
          (f) =>
            new Date(user.ClearNotificationsFrom) <= new Date(f.Timestamp) &&
            !f.SeenBy.some((c) => c._id === user._id)
        )
    : null;

/**
 * @param {array} messagesCollection
 * @param {object} loggedUser
 * @param {object} channel
 * @param {array} typesToFilter
 * @param {array} channelStateToFilter
 * @return
 */
export const getUnseenMessages = (
  messagesCollection,
  loggedUser,
  channel,
  typesToFilter,
  channelStateToFilter
) =>
  messagesCollection.filter(
    (m) =>
      !!(
        loggedUser &&
        (m?.MarkedAsUnreadBy?.includes(loggedUser._id) ||
          new Date(loggedUser.ClearNotificationsFrom) <= new Date(m.Timestamp)) &&
        !m.SeenBy.some((c) => c._id === loggedUser._id) &&
        m.MessageType &&
        m.MessageType.TypeId !== utils.MessageTypeEnum.AutoReply.TypeId &&
        m.MessageType.TypeId !== utils.MessageTypeEnum.System.TypeId &&
        !m.IsDeleted &&
        (m?.Sender?.ContactType?.TypeId && !m?.MarkedAsUnreadBy?.includes(loggedUser._id)
          ? m.Sender.ContactType.TypeId === utils.ContactTypeEnum.Customer.TypeId ||
            m.Sender.ContactType.TypeId === utils.ContactTypeEnum.WebChatContact.TypeId
          : true) &&
        (channel ? channel._id === m.Channel._id : true) &&
        (typesToFilter && m.Channel?.ChannelType?.TypeId
          ? typesToFilter.some((s) => s === m.Channel.ChannelType.TypeId)
          : true) &&
        (channelStateToFilter && m.Channel?.ChannelStateType?.TypeId
          ? channelStateToFilter.some((s) => s === m.Channel.ChannelStateType.TypeId)
          : true)
      )
  );

/**
 * @param {object} message
 * @return
 */
export const getFormattedTimestamp = (message) => {
  const messageTimestamp = message?.Timestamp ? new Date(message.Timestamp) : null;
  let formattedTimestamp = null;

  if (messageTimestamp) {
    formattedTimestamp = formatLatestMessageTimestamp(messageTimestamp);
  }

  return formattedTimestamp;
};

/**
 * @param {object} previousMessage
 * @param {object} newMessage
 * @return
 */
export const checkPreviousMessageType = (previousMessage, newMessage) =>
  previousMessage.MessageType.TypeId === newMessage.MessageType.TypeId &&
  (previousMessage.MessageType.TypeId === utils.MessageTypeEnum.System.TypeId ||
    previousMessage.Sender?._id === newMessage.Sender?._id);

/**
 * @param {array} messagesCollection
 * @param {object} channel
 * @param {bool} showHiddenMessages
 * @return
 */
export const getFilteredMessagesForChannel = (
  messagesCollection,
  channel,
  showHiddenMessages,
  hiddenMessages
) => {
  if (channel) {
    return messagesCollection
      .filter(
        (f) =>
          f.Channel._id === channel._id &&
          // f.MessageType.TypeId !== utils.MessageTypeEnum.ClosedChannelMessage.TypeId &&
          (!showHiddenMessages ? !hiddenMessages.includes(f._id) : true)
      )
      .sort((a, b) => new Date(a.Timestamp) - new Date(b.Timestamp));
  }

  return [];
};

/**
 * @param {object} message
 * @param {string} loggedUserId
 * * @param {object} location
 * @return
 */
export const readByContact = (message, loggedUserId, location) =>
  location.clearNotificationsFromForUser >= message.Timestamp ||
  message.SeenBy.some((c) => c._id === loggedUserId);

/**
 * @param {object} message
 * @param {string} loggedUserId
 * * @param {object} location
 * @return
 */
export const getUnseenMessageByContact = (message, loggedUser, location) =>
  message &&
  loggedUser &&
  (message?.MarkedAsUnreadBy?.some((s) => s === loggedUser._id) ||
    new Date(location.clearNotificationsFromForUser) <= new Date(message.Timestamp)) &&
  !message.SeenBy.some((c) => c._id === loggedUser._id) &&
  message.MessageType &&
  message.MessageType.TypeId !== utils.MessageTypeEnum.AutoReply.TypeId &&
  message.MessageType.TypeId !== utils.MessageTypeEnum.System.TypeId &&
  !message.IsDeleted &&
  (message?.Sender?.ContactType?.TypeId
    ? message.Sender.ContactType.TypeId === utils.ContactTypeEnum.Customer.TypeId ||
      message.Sender.ContactType.TypeId === utils.ContactTypeEnum.WebChatContact.TypeId
    : true);
